<template>
  <section class="search-section container">
    <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>机型搜索</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="productList.length">
      <product-list product-img @onProductChanged="productTap" :list="productList"></product-list>
      <Pagination
        :total="+pageInfo.total"
        :pageSize="+pageInfo.pageSize"
        :pageIndex="+pageInfo.pageIndex"
        @current-change="onPageIndexChanged"
        ></Pagination>
        <p v-show="false">{{ pageInfo }}</p>
    </template>
    <div v-else class="text-muted no-result">
      <div>
        很抱歉！没有找到相关的机型<br>
        小宝建议您：<br>
        1. 看看输入的文字是否有误；<br>
        2. 减少关键词数量，扩大搜索范围， 如“vivo X5L 蓝宝石版”去掉“蓝宝石版” ；<br>
        3. 如果重新搜索还是没有找到您的机型，请联系在线客服，或者拨打400-661-2099咨询客服。
      </div>
    </div>
  </section>
</template>

<script>
import searchStore from './store';
import { mapState } from 'vuex';
import Pagination from '@/components/pagination';
import { Breadcrumb, BreadcrumbItem } from 'element-ui';
import ProductList from '@/core/product-list/product-list';

export default {
  components: {
    Pagination,
    ProductList,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem
  },
  registerModule (store, preserveState) {
    store.registerModule('searchStore', searchStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('searchStore');
  },
  asyncData ({ store, route }) {
    return store.dispatch('searchStore/getProductsByKey', {
      key: route.query.key
    });
  },
  computed: {
    ...mapState({
      key: state => state.searchStore.key,
      pageInfo: state => state.searchStore.pageInfo,
      productList: state => state.searchStore.productList
    })
  },
  watch: {
    productList (val) {
      if (!this.$isServer) {
        try {
          document.documentElement.scrollTop = 0;
        } catch (e) {
          console.warn(`error source: document.documentElement.scrollTop = 0`);
        }
      }
    }
  },
  methods: {
    productTap (data) {
      if (!data.productId) return;
      this.$router.push({
        name: 'ProductInfo',
        params: {
          productId: data.productId
        }
      });
    },
    onPageIndexChanged (pageIndex) {
      this.$store.dispatch('searchStore/getProductsByKey', { pageIndex });
    }
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.no-result {
  min-height: 600px;
  padding: 20px;
  font-size: 16px;
  line-height: 24px;
  background: #fff;
}

.search-section {
  /deep/ .pager-list {
    padding: 20px 0;
  }
  /deep/ .pager-item {
    margin: 0;
    a {
      display: inline-block;
      height: 30px;
      padding: 0 6px;
      min-width: 40px;
      margin-right: -1px;
      line-height: 30px;
      color: #666;
      text-align: center;
      border: 1px #eee solid;
      &:hover {
        z-index: 2;
        position: relative;
        color: #3b9bff;
        border-color: #3b9bff;
      }
    }
    &.is-active a {
      z-index: 2;
      position: relative;
      color: #3b9bff;
      border-color: #3b9bff;
    }
  }

  /deep/ .product-list {
    margin-right: -20px;
    .product-item {
      margin: 0;
      margin-bottom: 17px;
      background-color: #fff;
      width: 224px;
      height: 256px;
      margin-right: 20px;
      .product-logo {
        height: 145px;
      }
      .product-name {
        margin-top: 35px;
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/search/index.vue